<div class="baseContainer" [ngClass]="!KeyboardService.IsOpen && 'invisible' || ''">
	<div class="simple-keyboard"></div>
</div>